module.exports = __webpack_public_path__ + "src/assets/img/share/tips/open/f0d023b95b5a93d5b0fab7228c1175fc.png";